import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { InputText, InputDate, InputDescription, PassBtn } from '../../../_imports';
import './experience_form.css';

function ExperienciaStep({ formData, addExperiencia, removeExperiencia, handleExperienciaChange, prevStep, errors }) {
  return (
    <fieldset>
      <legend>Experiência Profissional</legend>

      {formData.map((item, index) => (
        <div key={item.id} className="CardFormacao">
          <div className="CardHeader">
            <h4>Experiência #{index + 1}</h4>
            <button
              type="button"
              className="BotaoExcluir"
              onClick={() => removeExperiencia(item.id)}
            >
              <FontAwesomeIcon icon={faTrash} /> Excluir
            </button>
          </div>
          <div className='sized-box'></div>
          <InputText
            label="Empresa:"
            id={`empresa-${item.id}`}
            name="empresa"
            value={item.empresa}
            onChange={(e) => handleExperienciaChange(index, e)}
            error={errors[index]?.empresa}
          />
          <div className='sized-box'></div>
          <InputText
            label="Cargo:"
            id={`cargo-${item.id}`}
            name="cargo"
            value={item.cargo}
            onChange={(e) => handleExperienciaChange(index, e)}
            error={errors[index]?.cargo}
          />
          <div className='sized-box'></div>
          <div className="LinhaCampos">
            <InputDate
              label="Data de Início:"
              id={`inicio_exp-${item.id}`}
              name="inicio_exp"
              value={item.inicio_exp}
              onChange={(e) => handleExperienciaChange(index, e)}
              error={errors[index]?.inicio_exp}
            />
            <InputDate
              label="Data de Fim:"
              id={`fim_exp-${item.id}`}
              name="fim_exp"
              value={item.fim_exp}
              onChange={(e) => handleExperienciaChange(index, e)}
            />
          </div>
          <div className='sized-box'></div>
          <InputDescription
            label="Descrição das Atividades:"
            id={`descricao_exp-${item.id}`}
            name="descricao_exp"
            value={item.descricao_exp}
            onChange={(e) => handleExperienciaChange(index, e)}
            rows={4}
          />
        </div>
      ))}

      <button
        type="button"
        className="BotaoAdicionar"
        onClick={addExperiencia}
      >
        <FontAwesomeIcon icon={faPlus} /> Adicionar Experiência
      </button>

      <div className="BotoesNavegacao">
        <PassBtn text="Anterior" onClick={prevStep} direction="prev" />
        <PassBtn text="Finalizar" type="submit" direction="next" />
      </div>
    </fieldset>
  );
}

export default ExperienciaStep;